import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS, IMAGES } from "../mock";
import { CtaBanner } from "./Home";

const FILTERS = ["All", "Building Development", "Commercial Construction", "Domestic Construction", "Specialised Construction"];

export default function Projects() {
  const [filter, setFilter] = useState("All");
  const list = filter === "All" ? PROJECTS : PROJECTS.filter((p) => p.type === filter);

  return (
    <main>
      <section className="pt-[140px] pb-12 bg-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-4 text-[11px] tracking-[0.2em] text-[#1A1D14]/60 mb-6">
            <span className="inline-block w-1.5 h-1.5 bg-[#B29774]" />
            <span>PROJECTS</span>
            <span className="w-10 h-px bg-[#1A1D14]/30" />
            <span>SELECTED WORK</span>
          </div>
          <h1 className="font-display text-[56px] md:text-[96px] leading-[0.95] font-medium tracking-[-0.03em]">
            Selected work.<br /><span className="text-[#1A1D14]/40">Built with purpose.</span>
          </h1>
        </div>
      </section>

      <section className="pb-8 bg-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-wrap gap-3">
          {FILTERS.map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`px-4 py-2 text-sm border transition-colors ${filter === f ? "bg-[#24291E] text-white border-[#24291E]" : "border-[#1A1D14]/20 text-[#1A1D14] hover:border-[#B29774] hover:text-[#B29774]"}`}
            >
              {f}
            </button>
          ))}
        </div>
      </section>

      <section className="pb-24 bg-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-6">
          {list.map((p) => (
            <div key={p.id} className="group cursor-pointer">
              <div className="relative overflow-hidden">
                <img
                  src={IMAGES[p.img]}
                  alt={p.title}
                  className="w-full h-[460px] object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute top-4 left-4 bg-[#F9F8F6] text-[10px] tracking-[0.25em] px-3 py-1.5">{p.year}</div>
              </div>
              <div className="mt-5 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display text-[24px] font-medium tracking-[-0.01em]">{p.title}</h3>
                  <div className="mt-1 text-sm text-[#1A1D14]/60">{p.type} — {p.location}</div>
                </div>
                <ArrowUpRight size={20} className="mt-1 text-[#1A1D14]/60 group-hover:text-[#B29774] transition-colors" />
              </div>
            </div>
          ))}
        </div>
      </section>

      <CtaBanner />
    </main>
  );
}
